import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import { SEO } from "../components/organisms/seo"
import { mapToSection } from "../components/sections/section_mapper"

const APIPage = ({ data, location }) => {
  const blocks = data.butterPage.body

  return (
    <Layout pathname={location.pathname}>
      {blocks.map((block) => mapToSection(block))}
    </Layout>
  )
}

export default APIPage

// eslint-disable-next-line react/jsx-pascal-case
export const Head = () => <SEO title="API" />

export const query = graphql`
  query ApisPageQuery {
    butterPage(slug: { eq: "api" }) {
      id
      slug
      page_type
      body {
        type
        fields {
          heading
          headline
          subheading
          subheadline
          update_banner_visible
          update_banner_kind
          update_banner_label
          update_banner_link
          plans {
            name
            cost_per_month
            plan_limits
            call_to_action_label
            call_to_action_link
            featured
          }
          image
          image_alt_text
          image_position
          body_text
          hubspot_id
          show_call_to_action
          call_to_action_link
          call_to_action_label

          left_column_icon
          left_column_heading
          left_column_body_text
          right_column_icon
          right_column_heading
          right_column_body_text

          features {
            label
          }
          entries {
            icon
            heading
            body_text
          }

          section_1_heading
          section_1_fields {
            name
          }
          section_2_heading
          section_2_fields {
            name
          }
          section_3_heading
          section_3_fields {
            name
          }

          resources {
            icon
            heading
            call_to_action_label
            call_to_action_link
            open_call_to_action_in_new_tab
          }
        }
      }
    }
  }
`
